<template>
  <div style="text-align: center;">
    <p style="margin-top: 15px;">Do you want to include a billable client?</p>
    <div style="text-align: center;">
      <button type="button" style="margin-right: 10px;" class="btn btn-fill btn-info inline-block" @click="closeModal">Add Client</button>
      <p-button wide class="inline-block" @click.native="skipAddClient">Skip</p-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    skipAddClient() {
      this.$eventHub.$emit('jobClientOrPoChecksComplete')
      this.closeModal()
    },
    closeModal() {
      this.$emit('close')
    }
  },
}
</script>
